import { useToast } from './ToastContext';
import './toast.css';

export function ToastViewport() {
  const { toasts, dismiss } = useToast();
  return (
    <div className="toasts">
      {toasts.map(t => (
        <button
          key={t.id}
          className={`toast toast--${t.tone}`}
          onClick={() => dismiss(t.id)}
          aria-label="dismiss"
        >
          <span className="toast__dot" />
          <span>{t.message}</span>
        </button>
      ))}
    </div>
  );
}
